module.exports = __webpack_public_path__ + "static/media/camel.cac32d49.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/carousel/camel.jpg
 ** module id = 421
 ** module chunks = 0
 **/